import { GraphQLField, GraphQLInputField, GraphQLSchema } from 'graphql';
import { orderBy } from 'lodash';
import * as monacoEditor from 'monaco-editor';

import { EditorBottomTab } from '../helpers/EditorBottomTab';

export interface ToggleEditorContext {
  editor: monacoEditor.editor.IStandaloneCodeEditor;
  variablesEditor: monacoEditor.editor.IStandaloneCodeEditor;
  schema: GraphQLSchema;
  setActiveEditorBottomTab: (tab: EditorBottomTab) => void;
  shouldManageVariables: boolean;
}

export type SortOrder =
  | 'alphabeticalAscending'
  | 'alphabeticalDescending'
  | 'none';
export function sortFields<
  T extends GraphQLField<unknown, unknown> | GraphQLInputField,
>(sortOrder: SortOrder, fields: T[]): T[] {
  return sortOrder === 'none'
    ? fields
    : orderBy(
        fields,
        ['name'],
        [sortOrder === 'alphabeticalAscending' ? 'asc' : 'desc'],
      );
}
